import {
    type
} from "os";

export default class checkoutDeliveryDetailsCtrl {
    constructor($scope, $http, $rootScope, $compile) {
        'ngInject';

        $scope.active_service = 0;
        $scope.shipping_services = {};
        $scope.ship_same = 0;
        $scope.bill_form = {};
        $scope.bill_form.regions = {};
        $scope.ship_form = {};
        $scope.ship_form.regions = {};
        $scope.shipping_services = [];
        $scope.shipping_services_loading = false;
        $scope.user_addresses = [];
        $scope.countries = [];
        $scope.validationOptions = {
            rules: {
                bill_email: {
                    regex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                }
            },
            messages: {
                bill_email: {
                    regex: "Please enter a valid email address."
                },
            },
            ignore: [],
            errorPlacement: function (error, element) {
                if ($(element).is(":radio")) {
                    var hidELement = $(element).parent().parent().parent();
                    error.appendTo(hidELement);

                } else if ($(element).is("select")) {

                    var hidELement = $(element).parent().find('span.select2.select2-container');
                    error.insertAfter(hidELement);

                } else if ($(element).is(":hidden")) {
                    var hidELement = $(element).parent();
                    error.insertAfter(hidELement);
                } else {
                    error.insertAfter(element);
                }
            },
            highlight: function (element, errorClass, validClass) {
                if ($(element).is(":hidden")) {
                    $(element)
                        .parent()
                        .addClass(errorClass)
                        .removeClass(validClass);
                } else {
                    $(element)
                        .addClass(errorClass)
                        .removeClass(validClass);

                    $(element)
                        .prev()
                        .addClass('top-error');

                    $(element)
                        .parent()
                        .addClass('error')
                }
            },
            unhighlight: function (element, errorClass, validClass) {

                if ($(element).is(":hidden")) {
                    $(element)
                        .parent()
                        .removeClass(errorClass)
                        .addClass(validClass);
                } else {
                    $(element)
                        .removeClass(errorClass)
                        .addClass(validClass);

                    $(element)
                        .prev()
                        .removeClass('top-error');

                    $(element)
                        .parent()
                        .removeClass('error')
                }
            }
        };

        $scope.showShippings = function () {
            var _show = false;
            try {
                if ($scope.ship_same == 1) {
                    _show =
                        $scope.bill_form.country > 0 && !$scope.shipping_services_loading && $scope.shipping_services.length > 0;
                } else {
                    _show =
                        $scope.ship_form.country > 0 && !$scope.shipping_services_loading && $scope.shipping_services.length > 0;
                }
            } catch (e) {

            }
            return _show;
        };

        $scope.getRegions = function (type) {
            var _country = 0;
            if (type == 1) {
                // $scope.bill_form.region = null;
                _country = $scope.bill_form.country;
                $('#billing_region_dd').attr('disabled', true);
                $('#billing_region_dd').next('span').find('.select2-selection__placeholder').html('-- LOADING');
            } else {
                // $scope.ship_form.region = null;
                _country = $scope.ship_form.country;
                $('#shipping_region_dd').attr('disabled', true);
                $('#shipping_region_dd').next('span').find('.select2-selection__placeholder').html('-- LOADING');
            }
            if (typeof _country === 'undefined') {
                return false;
            }

            $http({
                method: "GET",
                url: "/checkout-delivery-details/get-all-areas/" + _country,
            }).then(function success(response) {
                var data = response.data;

                if (type == 1) {
                    $scope.bill_form.regions = data;
                    $scope.bill_form.region = $scope.bill_form.region_selected;
                    $('#billing_region_dd').attr('disabled', false);
                } else {
                    $scope.ship_form.region = $scope.ship_form.region_selected;
                    $('#shipping_region_dd').attr('disabled', false);
                    $scope.ship_form.regions = data;
                }
            }, function error(response) {
                var data = response.data;
            });
        };

        $scope.getShipping = function (event) {
            if (!$scope.saveDeliveryDetailsForm.validate()) {
                event.preventDefault();

                var firstError = angular.element(document).find('.input-wrapper.error')[0];
                if (firstError) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(firstError).offset().top - 60
                    }, 1000);
                }

                return false;
            }

            $rootScope.showOverlay('container-wrap');
            event.preventDefault();
            $scope.shipping_services = [];
            $scope.shipping_services_loading = true;

            $('#services-wrap').fadeOut();

            var params = {};
            if ($scope.ship_same == 1) {
                params = $scope.bill_form;
                params.fname = $scope.bill_form.fname;
                params.lname = $scope.bill_form.lname;
                params.phone = $scope.bill_form.phone;
                params.country = $scope.bill_form.country;
                params.region = $scope.bill_form.region;
                params.code = $scope.bill_form.code;
                params.city = $scope.bill_form.city;
                params.address = $scope.bill_form.address;
            } else {
                params = $scope.ship_form;
                params.fname = $scope.ship_form.fname;
                params.lname = $scope.ship_form.lname;
                params.phone = $scope.ship_form.phone;
                params.country = $scope.ship_form.country;
                params.region = $scope.ship_form.region;
                params.code = $scope.ship_form.code;
                params.city = $scope.ship_form.city;
                params.address = $scope.ship_form.address;
            }

            if (params.country > 0) {
                $http({
                    method: "POST",
                    url: "/en/checkout-delivery-details/calculate-shippings",
                    data: $rootScope.params(params),
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                })
                .then(function success(response) {
                    var data = response.data;
                    $scope.shipping_services_loading = false;
                    $scope.shipping_services_errors = data.errors
                    $scope.shipping_services = data.shipping;
                    // $rootScope.hideOverlay('container-wrap');
                    console.log('getShipping: ', data);
                    if( data.hasOwnProperty('errors') && data.errors.length>0 || data.shipping.length == 0){
                        $rootScope.hideOverlay('container-wrap');
                    }else{
                        $scope.setService(data.shipping[0]);
                        setTimeout(function(){
                            angular.element('#nextStepButton').click();
                        }, 1000);
                    }
                }, function error(response) {
                    var data = response.data;
                    $rootScope.hideOverlay('container-wrap');
                    console.log('getShipping: ', data);
                });
                // .then(function success(response) {
                //     var data = response.data;
                //     $scope.shipping_services_loading = false;
                //     $scope.shipping_services_errors = data.errors
                //     $scope.shipping_services = data.shipping;
                //     $rootScope.hideOverlay('container-wrap');
                //     console.log('getShipping: ', data);
                // }, function error(response) {
                //     var data = response.data;
                //     $rootScope.hideOverlay('container-wrap');
                //     console.log('getShipping: ', data);
                // });
            }
        };

        $scope.setService = function (service) {
            $scope.active_service = service;
        }

        $scope.saveDeliveryDetails = function (event) {
            if (!$scope.saveDeliveryDetailsForm.validate()) {
                event.preventDefault();
                var firstError = angular.element(document).find('.input-wrapper.error')[0];
                if (firstError) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(firstError).offset().top - 60
                    }, 1000);
                }
            } else {
                $rootScope.showOverlay('container-wrap');
            }
        }

        $scope.init = function () {
            setTimeout(function () {
                $('#billing_country_dd').change();
                $('#billing_region_dd').change();

                $('#shipping_country_dd').change();
                $('#shipping_region_dd').change();
            }, 1000)
        }

        $scope.init();

        /**
         * Watchers 
         */

        $scope.$watch("ship_same", function (newValue, oldValue) {
            $scope.shipping_services = [];
        });

        /*-------------------------------------------------------------\
         * 
         * BILLING
         * 
         *-------------------------------------------------------------/
         */

        // Billing Info Collection
        $scope.$watchCollection("bill_form", function (newValue, oldValue) {
            $scope.shipping_services = [];
            if (!$scope.$$phase) {

            }
        });

        // Billing address select
        $scope.$watch("bill_form_selected", function (newValue, oldValue) {
            console.log(newValue)
            if (typeof newValue !== 'undefined' && !isNaN(newValue)) {
                if (newValue == 0) {
                    $scope.bill_form = {
                        address: '',
                        apt: '',
                        city: '',
                        code: '',
                        country: 0,
                        region: 0,
                        regions: [],
                    };
                } else {
                    if ($scope.user_addresses.hasOwnProperty(newValue)) {
                        var tmp = angular.copy($scope.user_addresses[newValue]);
                        var mRegions = angular.copy($scope.bill_form.regions);
                        tmp.regions = mRegions;
                        tmp.region_selected = tmp.region;
                        $scope.bill_form = tmp;
                    }
                }
            }
        });

        // Billing country
        $scope.$watch("bill_form.country", function (newValue, oldValue) {
            if (typeof newValue !== 'undefined' && !isNaN(newValue) && newValue > 0) {
                setTimeout(function () {
                    $scope.getRegions(1);
                    $scope.bill_form.country_name = $scope.countries[newValue];
                    $('#select2-billing_country_dd-container').text($scope.bill_form.country_name);
                }, 10);
            }
        });

        // Billing region
        $scope.$watch("bill_form.region", function (newValue, oldValue) {
            if (typeof newValue !== 'undefined' && !isNaN(newValue) && newValue > 0) {
                
                try {
                    $scope.bill_form.region_name = $scope.bill_form.regions[newValue];
                    $('#select2-billing_region_dd-container').text($scope.bill_form.region_name);
                    setTimeout(function () {
                        $('#billing_region_dd').valid();
                    }, 200);
                } catch (e) {

                }

                
            }
        });

        /*-------------------------------------------------------------\
         * 
         * SHIPPING
         * 
         *-------------------------------------------------------------/
         */

        // Shipping Info Collection
        $scope.$watchCollection("ship_form", function (newValue, oldValue) {
            $scope.shipping_services = [];
            if (!$scope.$$phase) {

            }
        });

        // Shipping address select
        $scope.$watch("ship_form_selected", function (newValue, oldValue) {
            if (typeof newValue !== 'undefined' && !isNaN(newValue)) {
                if (newValue == 0) {
                    $scope.ship_form = {
                        address: '',
                        apt: '',
                        city: '',
                        code: '',
                        country: 0,
                        region: 0,
                        regions: [],
                    };
                } else {
                    if ($scope.user_addresses.hasOwnProperty(newValue)) {
                        var tmp = angular.copy($scope.user_addresses[newValue]);
                        var mRegions = angular.copy($scope.ship_form.regions);
                        tmp.regions = mRegions;
                        tmp.region_selected = tmp.region;
                        $scope.ship_form = tmp;
                    }
                }
            }
        });

        // Shipping country
        $scope.$watch("ship_form.country", function (newValue, oldValue) {
            if (typeof newValue !== 'undefined' && !isNaN(newValue) && newValue > 0) {
                setTimeout(function () {
                    $scope.getRegions(2);
                    $scope.ship_form.country_name = $scope.countries[newValue];
                    $('#select2-shipping_country_dd-container').text($scope.ship_form.country_name);
                }, 10);
            }
        });

        // Shipping region
        $scope.$watch("ship_form.region", function (newValue, oldValue) {
            if (typeof newValue !== 'undefined' && !isNaN(newValue) && newValue > 0) {
                try {
                    $scope.ship_form.region_name = $scope.ship_form.regions[newValue];
                    $('#select2-shipping_region_dd-container').text($scope.ship_form.region_name);
                    setTimeout(function () {
                        $('#shipping_region_dd').valid();
                    }, 200);
                } catch (e) {

                }
            }
        });

        $scope.$watchCollection("ship_form.regions", function (newValue, oldValue) {
            if (typeof newValue !== 'undefined' && !isNaN(newValue) && newValue > 0) {
                try {
                    $scope.ship_form.region_name = $scope.ship_form.regions[newValue];
                    $('#select2-shipping_region_dd-container').text($scope.ship_form.region_name);
                } catch (e) {

                }
            }
        });
    }
}